export const REQUEST_MESSAGES_LIST = '@MESSAGES/REQUEST_MESSAGES_LIST'
export const SET_MESSAGES_LIST = '@MESSAGES/SET_MESSAGES_LIST'
export const SET_PAGE = '@MESSAGES/SET_PAGE'
export const REQUEST_DELETE_MESSAGE = '@MESSAGES/REQUEST_DELETE_MESSAGE'
export const SET_MESSAGES_LOADING = '@MESSAGES/SET_MESSAGES_LOADING'
